import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { SessaoService } from '../services/sessao.service';

@Component({
  selector: 'app-open-banking',
  templateUrl: './open-banking.component.html',
  styleUrls: ['./open-banking.component.css']
})
export class OpenBankingComponent implements OnInit {

  url: any;

  constructor(
    public sanitizer: DomSanitizer,
    private sessaoService: SessaoService
  ) { }

  ngOnInit() {
    console.log(`${environment.urlOpenBanking}${this.sessaoService.sessao.autenticado.nuCTRL}`);
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.urlOpenBanking}${this.sessaoService.sessao.autenticado.nuCTRL}`);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/open-banking/open-banking.component.ts